module.exports = __webpack_public_path__ + "static/media/14_offline.0f3ac27a.png";